exports.default = {
  'cancel': '取 消',
  'confirm': '确 定',
  'confirm_upload': '确认上传',
  'submit': '提 交',
  'copy_success': '复制成功',
  'copy_failed': '复制失败，请稍后重试！',
  'delete': '删除',
  'upload_image': '上传图片',
  'copy': '复制',
  'close': '关 闭',
  'operation_failed': '操作失败，请稍后重试',
  'operation_success': '操作成功！',
  'form_not_complete': '表单填写不完整，请检查后重新提交！',
  'executing': '执行中...',
  'crop_image': '剪切图片',
  'crop': '剪切',
  'tips': '提 示',
  'refresh': '刷 新',
  'upload_without_crop': '不剪切直接上传',
  'save_success': '保存成功！',
  'image_type_error': '图片类型必须是.gif,jpeg,jpg,png,bmp中的一种',
  'add_success': '添加成功',
  'verification_failed': '验证码校验失败',
  'loading': '加载中',
  'no_more': '没有更多了',
  'your_agents': '您的智能体',
  'edit_avatar': '修改头像',
  'save_note': '保存笔记',
  'share': '分享',
  'network_error': '网络错误，发送失败。',
  'single_image_size_no_more_than_50M': '单张图片大小不超过20M，最多同时上传10张图片。',
  'please_enter_your_question_or_requirement': '请输入你的问题或需求。按Enter发送消息，Ctrl+Enter / Shift+Enter换行',
  'account_logout_need_relogin': '当前账号已被退出，请重新登录',
  'account_identity_changed_refresh_required': '当前登录账号身份已变更,请刷新后重试',
  'team_disbanded_switch_notice': '当前团队已解散，3秒后将自动切换到您的个人团队。',
  'team_membership_lost_switch_notice': '您已不再属于当前团队，3秒后将自动切换到您的个人团队。',
  'invalid_webpage': '无效的网页'
}
